import { createAction, props } from "@ngrx/store";
import {
  Purchase,
  PurchaseHeader,
  PurchaseItem,
} from "app/modules/transactions/purchase/models/purchase.model";

export const savePurchaseHeader = createAction(
  "[Purchase Form] Save Header",
  props<{ header: PurchaseHeader }>()
);

export const savePurchaseItems = createAction(
  "[Purchase Form] Save Items",
  props<{ items: PurchaseItem[] }>()
);

export const addPurchaseItem = createAction(
  "[Purchase Form] Add Item",
  props<{ item: PurchaseItem }>()
);

export const createPurchase = createAction(
  "[Purchase] Create Purchase",
  props<{ purchase: Purchase }>()
);

export const createPurchaseSuccess = createAction(
  "[Purchase] Create Purchase Success",
  props<{ response: any }>()
);

export const createPurchaseFailure = createAction(
  "[Purchase] Create Purchase Failure",
  props<{ error: any }>()
);

// Update
export const updatePurchase = createAction(
  "[Purchase] Update Purchase",
  props<{ purchaseId: string; purchase: Purchase }>()
);

export const updatePurchaseSuccess = createAction(
  "[Purchase] Update Purchase Success",
  props<{ response: PurchaseHeader }>()
);

export const updatePurchaseFailure = createAction(
  "[Purchase] Update Purchase Failure",
  props<{ error: any }>()
);

// Load for Edit
export const loadPurchaseById = createAction(
  "[Purchase] Load Purchase By ID",
  props<{ purchaseId: string }>()
);

export const loadPurchaseByIdSuccess = createAction(
  "[Purchase] Load Purchase By ID Success",
  props<{ purchase: PurchaseHeader }>()
);

export const loadPurchaseByIdFailure = createAction(
  "[Purchase] Load Purchase By ID Failure",
  props<{ error: any }>()
);

// Load last item details
export const loadLastPurchaseDetails = createAction(
  "[Purchase] Load Last Purchase Details",
  props<{ itemId: string; supplierId: string; rowIndex: number }>()
);

export const loadLastPurchaseDetailsSuccess = createAction(
  "[Purchase] Load Last Purchase Details Success",
  props<{ rowIndex: number; itemDetails: any }>()
);

export const loadLastPurchaseDetailsFailure = createAction(
  "[Purchase] Load Last Purchase Details Failure",
  props<{ rowIndex: number; error: any }>()
);

export const clearPurchaseForm = createAction("[Purchase Form] Clear Form");
